import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Modal,
  TransitionablePortal,
  Form,
  TextArea,
  Confirm,
  Button,
} from "semantic-ui-react";
import { contactCsa, resetContactCsa } from "../store/actions/athleteActions";

const initialState = {
  contactName: "",
  contactNameChanged: false,
  contactEmail: "",
  contactEmailChanged: false,
  formComments: "",
  formCommentsChanged: false,
  changesMade: false,
  confirmOpen: false,
  tryingToSend: false,
};

class ContactForm extends Component {
  constructor(props) {
    super(props);

    this.state = initialState;
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState(
      {
        tryingToSend: true,
      },
      () => {
        this.props.contactCsa(this.state);
      }
    );
  };

  trackChanges = () => {
    if (
      this.state.contactNameChanged ||
      this.state.contactEmailChanged ||
      this.state.formCommentsChanged
    ) {
      this.setState({
        changesMade: true,
      });
    } else {
      this.setState({
        changesMade: false,
      });
    }
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });

    this.setState(
      {
        [e.target.id]: e.target.value,
      },
      () => {
        switch (e.target.id) {
          case "contactName":
            if (e.target.value !== "") {
              this.setState(
                {
                  contactNameChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  contactNameChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "contactEmail":
            if (e.target.value !== "") {
              this.setState(
                {
                  contactEmailChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  contactEmailChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          case "formComments":
            if (e.target.value !== "") {
              this.setState(
                {
                  formCommentsChanged: true,
                },
                () => {
                  this.trackChanges();
                }
              );
            } else {
              this.setState(
                {
                  formCommentsChanged: false,
                },
                () => {
                  this.trackChanges();
                }
              );
            }
            break;
          default:
            return;
        }
      }
    );
  };

  handleClose = () => {
    if (this.state.changesMade) {
      this.confirmOpen();
    } else {
      this.props.contactClose();
    }
  };

  handleExit = () => {
    this.setState(initialState, () => {
      this.props.resetContactCsa();

      this.props.contactClose();
    });
  };

  confirmOpen = () => this.setState({ confirmOpen: true });

  confirmClose = () => {
    this.setState(initialState, () => {
      this.handleClose();
    });
  };

  confirmCloseCancel = () =>
    this.setState({
      confirmOpen: false,
    });

  render() {
    const { contactRequestSent } = this.props;

    const animation = "scale";
    const duration = 500;

    var saveButton = null;
    var infoRequestStatus = null;

    const formName = (
      <input
        placeholder="Name"
        id="contactName"
        value={this.state.contactName}
        onChange={this.handleChange}
      />
    );
    const formEmail = (
      <input
        placeholder="Email"
        id="contactEmail"
        value={this.state.contactEmail}
        onChange={this.handleChange}
      />
    );
    const formComments = (
      <TextArea
        placeholder="Comments"
        id="formComments"
        value={this.state.formComments}
        onChange={this.handleChange}
      />
    );

    if (
      this.state.contactName !== "" &&
      this.state.contactEmail !== "" &&
      this.state.formComments !== "" &&
      !this.state.tryingToSend
    ) {
      saveButton = (
        <Button
          floated="right"
          positive
          name="saveButton"
          content="Submit"
          labelPosition="right"
          icon="paper plane"
          onClick={this.handleSubmit}
        />
      );
    } else {
      if (this.state.tryingToSend) {
        saveButton = (
          <Button
            disabled
            loading
            floated="right"
            positive
            name="saveButton"
            content="Submit"
            labelPosition="right"
            icon="paper plane"
            onClick={this.handleSubmit}
          />
        );
      } else {
        saveButton = (
          <Button
            disabled
            floated="right"
            positive
            name="saveButton"
            content="Submit"
            labelPosition="right"
            icon="paper plane"
            onClick={this.handleSubmit}
          />
        );
      }
    }

    if (contactRequestSent) {
      infoRequestStatus = (
        <TransitionablePortal
          transition={{ animation, duration }}
          open={contactRequestSent}
          onClose={this.handleExit}
        >
          <Modal onClose={this.handleExit} open={true}>
            <Modal.Content scrolling>
              <div className="AdminProfileUpdatedContainer">
                <h3>Thank You! - We'll Contact You Soon!</h3>
                <Button
                  positive
                  name="okButton"
                  content="OK"
                  onClick={this.handleExit}
                />
              </div>
            </Modal.Content>
          </Modal>
        </TransitionablePortal>
      );
    }

    const athleteRequestForm = (
      <div className="AdminFormContainer">
        <Form>
          <div className="AdminFormPersonalInfoContainer">
            <h3>Contact CSA:</h3>
            <Form.Field required>
              <label>Your Email</label>
              {formEmail}
            </Form.Field>
            <Form.Field required>
              <label>Your Name</label>
              {formName}
            </Form.Field>
            <Form.Field required>
              <label>Comments</label>
              {formComments}
            </Form.Field>
          </div>
          {infoRequestStatus}
        </Form>
      </div>
    );

    return (
      <TransitionablePortal
        transition={{ animation, duration }}
        open={this.props.contact}
        onClose={() => this.handleClose()}
      >
        <Modal onClose={() => this.handleClose()} open={true}>
          <Modal.Content>
            <div className="AdminTopButtonsProgressContainer">
              <div className="AdminTopButtonsContainer">
                <Button
                  floated="left"
                  circular
                  icon="close"
                  onClick={() => this.handleClose()}
                />
                {saveButton}
              </div>
            </div>
            {athleteRequestForm}
            <Confirm
              open={this.state.confirmOpen}
              content="You have unsaved changes.  Are you sure you want to exit?"
              onCancel={this.confirmCloseCancel}
              onConfirm={this.confirmClose}
            />
          </Modal.Content>
        </Modal>
      </TransitionablePortal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contactRequestError: state.athlete.contactRequestError,
    contactRequestSent: state.athlete.contactRequestSent,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    contactCsa: (requestInfo) => dispatch(contactCsa(requestInfo)),
    resetContactCsa: () => dispatch(resetContactCsa()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm);
